import { useState, useEffect } from "react";
import { Button } from "devextreme-react";
import useSnackbar from "../../hooks/useSnackbar";

import { taxPortalClientApi } from "../../api-client-nswag/taxportal-client-runtime";
import { defaultPageSize } from "../../constants";
import { SnackbarMessage } from "../../hooks/useSnackbar.types";
import { useRecoilValue } from "recoil";
import AppNameToggleForSiteMetric, { getAppNameSiteMetric } from "../../cui/commonComponents/AppNameToggleForSiteMetric";
import { getSitesRequests } from "../../cui/commonComponents/SitesRequestsToggle";
import { GetAllSiteMetricsDTO } from "../../api-client-nswag/taxportal-client";
import { SitesBreakdownPBI } from "./SitesBreakDownPBI";
import SiteMetricsRunFunctions from "./SiteMetricsRunFunctions";
import {models,Report} from "powerbi-client";
import ExcelJS from "exceljs";
import Papa from "papaparse";

export const SiteMetrics = () => {
  const { showSnackbar, showSuccessSnackbar } = useSnackbar();
  const [pageNumber, setpageNumber] = useState(1);
  const appName = useRecoilValue(getAppNameSiteMetric);
  const siteRequests = useRecoilValue(getSitesRequests);
  const [exportData, setExportData] = useState<GetAllSiteMetricsDTO[] |undefined>();
  const [siteReports, setSiteReports] = useState<Report | null>(null);

  const fetchExportSites = async() => {
    const startIndex = pageNumber === 1 ? 0 : (pageNumber - 1) * defaultPageSize;
    const data = await taxPortalClientApi.highQ_GetSiteMetricsInfo(appName, siteRequests, startIndex, defaultPageSize)
    setExportData(data?.data);
  }

  const exportButtonOptions = async () => {
      if (siteReports) {
        try {
          const pages = await siteReports.getPages();
          const activePage = pages.find((page) => page.isActive);
    
          if (activePage) {
            const visuals = await activePage.getVisuals();
            const tableVisual = visuals.find(
              (visual) => visual.type === "tableEx"
            );
    
            if (tableVisual) {
              const exportedData = await tableVisual.exportData(models.ExportDataType.Summarized);
              
              const parsed = Papa.parse(exportedData.data, { skipEmptyLines: true });
              const workbook = new ExcelJS.Workbook();
              const worksheet = workbook.addWorksheet("Filtered Data");

              parsed.data.forEach((row: string[] | any) => {
                worksheet.addRow(row);
              });

              try {
                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "Site Creation Summary.xlsx";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
                showSuccessSnackbar({ message: SnackbarMessage.EXPORT_TO_EXCEL_SUCCESS });
              } catch (err) {
                showSnackbar({ message: SnackbarMessage.EXPORT_TO_EXCEL_FAIL, severity: "error" });
              }
            } else {
              showSnackbar({ message: SnackbarMessage.EXPORT_TO_EXCEL_FAIL, severity: "error" });
            }
          } else {
            showSnackbar({ message: SnackbarMessage.EXPORT_TO_EXCEL_FAIL, severity: "error" });
          }
        } catch (error) {
          showSnackbar({ message: SnackbarMessage.EXPORT_TO_EXCEL_FAIL, severity: "error" });
        }
      } 
    };

  useEffect(() => {
      fetchExportSites();
    // eslint-disable-next-line
  }, [appName]);

  return (
    <div style={{ margin: "20px 20px 20px 20px", display: "flex", flexDirection: "column" }}>
    <div style={{
          display: "flex",
          margin:"0 0 8px 0"
        }}>
      <h2>Site Metrics</h2>
      <AppNameToggleForSiteMetric />
      { appName === "Sites" && (
      <div style={{
              top:30,
              position: "absolute",
              right: 10,
            }}>
      <Button text="Export" hint="Export to Excel" icon="exportxlsx" onClick={exportButtonOptions} />
      </div>
      )}
    </div>
    <div>
      {appName === "Sites" &&
        <div style={{ position: "relative", marginTop: "20px" }}>
          <SitesBreakdownPBI appName={appName} exportData = {exportData} setSiteReports={setSiteReports} siteReports={siteReports}/>
        </div>
}
      {appName === "Other" &&
        <div style={{ position: "relative", marginTop: "20px" }}>
          <SiteMetricsRunFunctions />
        </div>
}
    </div>
  </div> 
);
};
